import { Component, ViewChild } from '@angular/core';
import { SharedModule, ToastMessageOptions } from 'primeng/api';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { CalloutComponent } from '../callout/callout.component';
import { Toast, ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-asset-cloned-toast',
  templateUrl: './asset-cloned-toast.component.html',
  styleUrls: ['./asset-cloned-toast.component.scss'],
  imports: [ToastModule, SharedModule, CalloutComponent, RouterLink, TranslateModule],
})
export class AssetClonedToastComponent {
  public readonly key = 'assetClonedToast';
  @ViewChild('toast') private toast: Toast | undefined;

  public onClose(message: ToastMessageOptions) {
    if (this.toast?.messages && this.toast.messages.length > 0) {
      const messageIndex = this.toast.messages.findIndex(entry => entry.id === message.id);
      if (messageIndex !== -1) {
        this.toast.messages?.splice(messageIndex, 1);
      }
    }
  }
}
